import { create } from 'zustand';
import { combine, devtools } from 'zustand/middleware';
import type { PaymentMethod, PaymentMethodCode } from '@/api/payment/types';

export const usePaymentMethodStore = create(
  devtools(
    combine(
      {
        selectedPaymentMethod: null as PaymentMethod | null,
        paymentCard: '' as string | null,
      },
      (set) => ({
        setSelectedPaymentMethod: (selectedPaymentMethod: PaymentMethod) => {
          set({ selectedPaymentMethod });
        },
        setAddPaymentCard: (paymentCard: string | null) => {
          set({ paymentCard });
        },
        resetSelectedPaymentMethodStore: () => {
          set({ selectedPaymentMethod: null as PaymentMethod | null });
        },
      })
    )
  )
);
